// extracted by mini-css-extract-plugin
export default {"container":"Assembly_container__FMqS0"};